import {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState
} from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash.debounce';

const SearchQueryStringContext = createContext('');

export function SearchQueryStringContextProvider({ children }) {
  const initialSearch = useMemo(() => {
    const {
      search
    } = Object.fromEntries(new URLSearchParams(window.location.search));
    return search;
  }, []);

  const [search, setSearch] = useState(initialSearch || '');

  const debounceUrlUpdate = useRef(debounce(async (query) => {
    const { title } = document;
    const url = new URL(window.location);

    url.searchParams.set('search', query);
    window.history.replaceState(null, title, url.toString());
  }, 1000));

  useEffect(() => {
    debounceUrlUpdate.current(search);
  }, [search]);

  const value = useMemo(() => ([search, setSearch]), [search]);
  return (
    <SearchQueryStringContext.Provider value={value}>
      {children}
    </SearchQueryStringContext.Provider>
  );
}

export const useSearchQueryStringContext = () => useContext(SearchQueryStringContext);

SearchQueryStringContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default SearchQueryStringContextProvider;
